import config from "../config.json";
import { saveTokens } from "./saveTokens";

const generateReport = async (reportParams) => {
  return new Promise((resolve) => {
    if(sessionStorage.getItem("role") === "admin"){
      if(!reportParams.access_key_ids){
       return resolve({ success: false, message: "Please select a parking" });
      }
    }
    
    fetch(`${config.HOST_NAME}/crm/requestReport`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        RefreshToken: `Bearer ${sessionStorage.getItem("refresh_token")}`,
      },
      body: JSON.stringify(reportParams),
    })
      .then((response) => {
        saveTokens(response);
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.success) resolve({ success: true });
        else resolve({ success: false, message: responseJson.message });
      })
      .catch((e) => {
        console.log(e)
        resolve({ success: false, message: "Error Generating Report" });
      });

  })

}


export {generateReport}